import AbsComponent from "../../components/AbsComponent";
import AutoSuggest from './AutoSuggest';

export default class SearchBox extends AbsComponent{
    constructor(_name='', _store={}, _actions={}, _router={}, _el=''){
        super(_name, _store, _actions, _router, _el);

        const { config } = this.store.getState();

        this.autoSuggest = new AutoSuggest();
        this.autoSuggest.init({
            isGDPRGeoCountry: config.isGDPRGeoCountry || false,
            apiUrl: `${config.apiDomain}/search/${_name}/suggest`,
            selector : '#gameInfoAutoSuggest',
            cookieName: 'lwGameInfoAutoSuggest'+_name,
            size: 10,
            useDelbtn: true,
            locale: config.locale,
            submitCallback: (_q)=>{
                this.goRouter(_q);
            }
        });

        let watchQuery = this.watch(this.store.getState, 'query', this.isEqual);
        this.store.subscribe( watchQuery( (newVal, oldVal, path) => this.render(newVal, oldVal, path)));
        this.render(this.store.getState().query);

        $("#gameInfoAutoSuggest [data-name='suggest_submit']").on('click', (e)=>{
            if ($("#gameInfoAutoSuggest [data-name='suggest_input']").val().trim() == '') {
                this.goRouter('');
            }
        });

        $("#gameInfoAutoSuggest [data-name='suggest_delete']").on('click', (e)=>{
            if ($("#gameInfoAutoSuggest [data-name='suggest_input']").val().trim() == '') {
                this.goRouter('');
            }
        });

        $('.gameinfo-search-wrapper .btn-filter').on('click', e =>{
            $('.gameinfo-filter-wrapper').addClass('is-active');
        });
    }

    render(_newVal, _oldVal, _path){
        this.autoSuggest.value(_newVal);
    }
    
    goRouter(_q){
        this.router.goMultiParam({query: _q, page: 1});
    }

} // end of class